<div class="form-group row">
  <label class="col-xl-3 col-lg-3 col-form-label">{{ label }}</label>
  <div class="col-lg-9 col-xl-6">
    <ng-content></ng-content>
  </div>
</div>
